var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstimatedTaxRateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0277 5.80799C10.9667 5.39816 10.4959 5.04927 10.0861 5.11021L6.8097 5.59743C6.89161 4.74746 6.97609 3.8994 6.91515 3.48957C6.79326 2.66991 6.26188 1.91343 6.02744 1.7377C6.0223 1.73388 5.79334 1.56421 5.38351 1.62515C4.76988 1.7164 4.86113 2.33003 4.86113 2.33003C4.86279 2.34122 4.80953 3.38379 4.87047 3.79362C4.92704 4.17407 4.43455 5.7171 4.08455 6.31303C4.03622 6.3953 3.9664 6.46104 3.88814 6.51563C3.72802 6.62732 3.64493 6.82004 3.67365 7.01314L4.42273 12.0505C4.45648 12.2775 4.63246 12.457 4.85872 12.4952C4.9137 12.5045 4.96979 12.505 5.02494 12.4968L9.41326 11.8443C10.2329 11.7224 10.5917 11.3116 10.5307 10.9017C10.4698 10.4919 9.99902 10.143 9.58919 10.204C10.4088 10.0821 10.7577 9.61131 10.6968 9.20148C10.6358 8.79165 10.1651 8.44276 9.75524 8.5037C10.5749 8.38181 10.9238 7.91104 10.8628 7.50121C10.8019 7.09138 9.80057 6.75778 9.39074 6.81873C10.2092 6.70389 11.0886 6.21782 11.0277 5.80799Z",
    fill: "#0E5CF4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.44434,
    y: 7.16943,
    width: 1.78345,
    height: 5.7962,
    rx: 0.891724,
    transform: "rotate(-8.45814 1.44434 7.16943)",
    fill: "#0E5CF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimatedTaxRateIcon);
export default __webpack_public_path__ + "static/media/estimatedTaxRateIcon.30fbab3b986f67258655e48adb0ffdf8.svg";
export { ForwardRef as ReactComponent };